import React from 'react'
import Image from 'next/image'
import Script from 'next/script'
import Link from 'next/link'
import StartaProject from '@/components/StartaProject'
import Head from 'next/head'
import { GetStaticPaths, GetStaticProps } from 'next'
import { getAllPostsWithSlug, getPostAndMorePosts, getRecentPosts } from '../../lib/post';
import { getSeoDataPost  } from '../../lib/seo';
import SEO from '@/components/SEO'
import BlogsForm from '@/components/blogs/BlogsForm'
import Cf7FormWrapper from '@/components/cf7-form-wrapper';
function BlogSingle({ post, posts, recentPosts, preview, initialSeo}:any) {

  function formatDate(date: number | undefined) {
    if (!date) {
      return '';
    }
  
    const formattedDate = new Date(date);
    const day = formattedDate.getDate().toString().padStart(2, '0'); // Get day and ensure 2-digit format
    const month = (formattedDate.getMonth() + 1).toString().padStart(2, '0'); // Get month and ensure 2-digit format
    const year = formattedDate.getFullYear().toString(); // Get full year
  
    return `${day}/${month}/${year}`;
  }

  return (
   <div className='blog_single_page'>
       <SEO initialSeo={initialSeo}/>
      <section className="blog_banner" style={{backgroundImage:`url(${post?.featuredImage?.node && post?.featuredImage?.node?.sourceUrl})`}}>
        <div className="container">
          <div className="bb_title">
              {post?.title && (
                  <h1  data-aos="fade" data-aos-delay="100">{post?.title}</h1>
              )}
          </div>
        </div>
      </section>
      <section className='section container_small'>
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="blog_info">
              {post && post.date && post.author && post.author.node && post?.author?.node?.name && (
                <span>Posted on {formatDate(post?.date)} by {post?.author?.node?.name}</span>
              )}
              </div>
              <div className="blogs_categoey">
                  <span>Posted under</span>
               
                    {post && Array.isArray(post?.categories?.edges) && (
                      <ul>
                          {post?.categories?.edges.map((category: any, index: any) => (
                            <li key={index}>
                              <Link  href={`/category/${category?.node?.slug}`} className="cat_tag">
                                  {category?.node?.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                 
              </div>
              <div className="default_typo" dangerouslySetInnerHTML={{ __html: post?.content || '' }}>
                
              </div>
            </div>
            <div className="col-lg-4">
              <div className="blog_sidebar">
                  <div id='getintouch' className="blog_side_box form_box">
                    <Cf7FormWrapper formId="550">
                      <BlogsForm />
                    </Cf7FormWrapper>
                  </div>
                  <div className="blog_side_box">
                    <div className="googlereviews">
                      <Script src="https://static.elfsight.com/platform/platform.js" data-use-service-core defer></Script>
                      <div className="elfsight-app-04ec6157-7063-43c4-bbb4-6a279e350c64"></div>
                    </div>
                  </div>
                  <div className="blog_side_box">
                      <div className="need_box">
                        <div className="nb_content">
                          <h2>Need a new website?</h2>
                          <p>Get in touch to find out how we can help you</p>
                          <Link href='#getintouch' className='section_scroll'>Speak to an Expert</Link>
                        </div>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <StartaProject/>
   </div>
  )
}

export default BlogSingle

export const getStaticProps: GetStaticProps = async ({
  params,
  preview = false,
  previewData,
}) => {
  const slug = params?.slug as string;
  const initialSeo = await getSeoDataPost(slug)
  const data = await getPostAndMorePosts(slug, preview, previewData);
  return {
    props: {
      preview,
      post: data.post,
      posts: data.posts,
      initialSeo,
    },
    revalidate: 10,
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const allPosts = await getAllPostsWithSlug();

  return {
    paths: allPosts.edges.map(({ node }: any) => `/blogs/${node.slug}`) || [],
    fallback: true,
  };
};
  